import React from "react";
import { Box, useTheme } from "@mui/material";

export interface SiteLayoutProps {
  children: React.ReactNode;
}

export function SiteLayout(props: SiteLayoutProps) {
  const { children } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default
      }}
    >
      <Box
        sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}
      >
        {children}
      </Box>
    </Box>
  );
}
